import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { PaymentMethodDtoPayload } from '@/modules/employee/employee.types';
import { formatPaymentMethod } from '@/modules/ReimburseMe/queries/useAddPaymentMethod.query';

export const useGetPaymentMethods = (employeeId?: string) => {
  const { data, isLoading } = useQuery(
    [API_URL.PAYMENT_METHODS, employeeId],
    employeeId
      ? () =>
          // TODO: the DTO is broken
          api.get<PaymentMethodDtoPayload[]>(API_URL.PAYMENT_METHODS, {
            params: { employee_id: employeeId },
          })
      : () => null
  );

  const formattedData = useMemo(
    () => (data?.data || []).map((paymentMethod) => formatPaymentMethod(paymentMethod)),
    [data]
  );

  return {
    isLoading,
    formattedData,
  };
};
